import { defineStore } from 'pinia';
import { notificationService } from '../services/notification.service';
import type { INotificationState } from '../types/notificationStore.type';

export const useNotificationStore = defineStore('notification', {
  state: (): INotificationState => ({
    countNotification: 0,
  }),
  actions: {
    async setNotification(): Promise<void> {
      const result = await notificationService.getNotificationCount({ isRead: false });
      if (result.isRight()) {
        this.countNotification = Math.max(0, result.value.data);
      }
    },
  },
}); 
